import {
  LOGOUT,
  LOGIN_BEGIN, LOGIN_SUCCESS, LOGIN_FAILURE,
  CLEAR_LOGIN_ERROR_STATE,
  RECONNECT_BEGIN, RECONNECT_SUCCESS, RECONNECT_FAILURE,
  MAIL_VERIFICATION_REQUEST_BEGIN, MAIL_VERIFICATION_REQUEST_SUCCESS, MAIL_VERIFICATION_REQUEST_FAILURE,
} from '../constants/ActionTypes'

const initialState = {
  isAuth: false,
  isLoginIn: false,
  loginError: null,
  hasLoggedOut: false,

  requestMailVerification: null,
  isLoadingMailVerificationRequest: false,
  mailVerificationRequestError: null,
}

const ReducerAuth = (state = initialState, action) => {
  switch (action.type) {
    //:: Login
    case LOGIN_BEGIN: {
      return { ...state, isLoginIn: true }
    }
    case LOGIN_SUCCESS: {
      return { ...state, isLoginIn: false, isAuth: true, jwt: action.payload.token, loginError: null }
    }
    case LOGIN_FAILURE: {
      let loginError = {}
      //let err = actionPayloadToError(action.payload, 'getAppServiceAccessKeys')

      if (action.payload && action.payload.status)
        loginError = action.payload

      return { ...state, isLoginIn: false, isAuth: false, jwt: null, loginError }
    }

    //:: Logout
    case LOGOUT: {
      document.cookie = "manager_tok=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
      window.location.href = '/login'

      return state
    }

    //:: CLEAR LOGIN ERRORS
    case CLEAR_LOGIN_ERROR_STATE: {
      return { ...state, loginError: null }
    }

    //:: Reconnect
    case RECONNECT_BEGIN: {
      return { ...state }
    }
    case RECONNECT_SUCCESS: {
      return { ...state, isAuth: true, jwt: action.payload.token }
    }
    case RECONNECT_FAILURE: {
      return { ...state }
    }

    //:: MAIL VERIFICATION
    case MAIL_VERIFICATION_REQUEST_BEGIN: {
      return { ...state, isLoadingMailVerificationRequest: true }
    }
    case MAIL_VERIFICATION_REQUEST_SUCCESS: {
      return {
        ...state, isLoadingMailVerificationRequest: false, mailVerificationRequestError: null, requestMailVerification: true
       }
    }
    case MAIL_VERIFICATION_REQUEST_FAILURE: {
      return { ...state, isLoadingMailVerificationRequest: false, mailVerificationRequestError: action.payload, requestMailVerification: null }
    }

    default: return state
  }
}

export default ReducerAuth